import {
  slateGrey,
  greyShades,
  fulvous,
  burntSierra,
  dollarBill,
  charcoal,
  pastelOrange

} from '@sukiai/components/lib/colors'

export const ROUTES = {
  ROOT: '/',
  DOCTOR_VIEW: '/:view',
  IMPLICIT_CALLBACK: '/implicit/callback',
  INTRO_PAGE: '/intro',
  LOGOUT: '/logout',
  LOGIN: '/login',
  REGISTER: '/register',
  REGISTER_SUCCESS: '/register/success',
  REGISTER_ERROR: '/register/error',
  GCP_REGISTER: '/gcp-register',
  GCP_REGISTER_SUCCESS: '/gcp-register/success',
  GCP_REGISTER_ERROR: '/gcp-register/error',
  RESET_PASSWORD: '/resetpassword',
  DEMO_APP: '/demo',
  ALTAIS_ENTRY: '/altais',

  WINDOWS_UPDATE: '/windowsupdate',

  // DOCTOR
  LANDING_PAGE: '/schedule',
  NOTE: '/note',
  PATIENT_NOTES: '/patient',
  PROFILE: '/profile',
  SCHEDULE: '/schedule',
  UNFINISHED_NOTES: '/unfinished-notes',
  HOME: '/home',
  HELP: '/help',
  SCRIPTS: '/scripts'
}

export const PUBLIC_ROUTES = [
  ROUTES.DEMO_APP,
  ROUTES.REGISTER,
  ROUTES.REGISTER_ERROR,
  ROUTES.REGISTER_SUCCESS,
  ROUTES.RESET_PASSWORD,
  ROUTES.GCP_REGISTER,
  ROUTES.GCP_REGISTER_ERROR,
  ROUTES.GCP_REGISTER_SUCCESS,
  ROUTES.WINDOWS_UPDATE
]

export const ALLOW_CROSS_BROWSER = [
  ROUTES.DEMO_APP,
  ROUTES.REGISTER,
  ROUTES.REGISTER_ERROR,
  ROUTES.REGISTER_SUCCESS,
  ROUTES.GCP_REGISTER,
  ROUTES.GCP_REGISTER_ERROR,
  ROUTES.GCP_REGISTER_SUCCESS
]

export const LO_STO = {
  AGENT_RECORDING: 'AGENT_RECORDING',
  AGENT_MUTED: 'AGENT_MUTED',
  AGENT_TEST_MODE: 'AGENT_TEST_MODE',
  AGENT_TEST_URL: 'AGENT_TEST_URL',
  AMWELL_APPOINTMENT_ID: 'AMWELL_APPOINTMENT_ID',
  ATHENA_ENCOUNTER_ID: 'ATHENA_ENCOUNTER_ID',
  ATHENA_PATIENT_ID: 'ATHENA_PATIENT_ID',
  COMP_BEING_CREATED: 'COMP_BEING_CREATED',
  CURRENT_COMPOSITION: 'CURRENT_COMPOSITION',
  CURRENT_APPT_ID: 'CURRENT_APPT_ID',
  CURRENT_COMP_CREATED_WITH_S2: 'CURRENT_COMP_CREATED_WITH_S2',
  CURRENT_COMP_ID: 'CURRENT_COMP_ID',
  CURRENT_NOTE_ID: 'CURRENT_NOTE_ID',
  CURRENT_NOTETYPE_ID: 'CURRENT_NOTETYPE_ID',
  CURRENT_PARENT_PBC_SECTION_ID: 'CURRENT_PARENT_PBC_SECTION_ID',
  CURRENT_PATIENT_ID: 'CURRENT_PATIENT_ID',
  CURRENT_PATH: 'CURRENT_PATH',
  CURRENT_STREAM_START_TIME: 'CURRENT_STREAM_START_TIME',
  CURRENT_SPEECH_ID: 'CURRENT_SPEECH_ID',
  CURRENT_TRACE_ID: 'CURRENT_TRACE_ID',
  CURRENT_USER: 'CURRENT_USER',
  CURRENT_ORGANIZATION: 'CURRENT_ORGANIZATION',
  HALF_STORY: 'HALF_STORY',
  FROM_PATIENT_LIST: 'FROM_PATIENT_LIST',
  IS_FIRST_TIME_USER: 'IS_FIRST_TIME_USER',
  IS_AMWELL_FIRST_TIME_USER: 'IS_AMWELL_FIRST_TIME_USER',
  IS_ALTAIS: 'IS_ALTAIS',
  IS_IMO_POWERED: 'IS_IMO_POWERED',
  ALTAIS_ERROR: 'ALTAIS_ERROR',
  KEYBOARD_MODE: 'KEYBOARD_MODE',
  LAST_AGENT_POSITION: 'LAST_AGENT_POSITION',
  LAST_AGENT_SIZE: 'LAST_AGENT_SIZE',
  LAST_AGENT_STATE: 'LAST_AGENT_STATE',
  LAST_OPENED_APPT: 'LAST_OPENED_APPT', // TO-DO: consolidate with current_appt_id and make more robust
  ORGANIZATION_ID: 'ORGANIZATION_ID',
  READ_ONLY_NOTE_CLICKED: 'READ_ONLY_NOTE_CLICKED',
  SCHEDULE_DATE: 'SCHEDULE_DATE',
  SESSION_ID: 'SESSION_ID',
  ACTIVE_TAB: 'ACTIVE_TAB',
  SHOULD_BYPASS_QA: 'SHOULD_BYPASS_QA',
  SHOULD_USE_STREAMING_GATEWAY: 'SHOULD_USE_STREAMING_GATEWAY',
  STREAM_INITIALIZED: 'STREAM_INITIALIZED',
  SUBMISSION_WARNING: 'SUBMISSION_WARNING',
  SUBMISSION_WARNING_MSG: 'SUBMISSION_WARNING_MSG',
  SUBMISSION_DESTINATIONS: 'SUBMISSION_DESTINATIONS',
  SUBMIT_PREFERENCE: 'SUBMIT_PREFERENCE',
  SUBMISSION_SUCCESSFUL: 'SUBMISSION_SUCCESSFUL',
  SUBMISSION_TRY_ALL_DESTINATION: 'SUBMISSION_TRY_ALL_DESTINATION',
  USER_ID: 'USER_ID',
  FHIR_ACCESS_TOKEN: 'FHIR_ACCESS_TOKEN',
  PRACTITIONER_ID: 'PRACTITIONER_ID',
  FHIR_ID_TOKEN: 'FHIR_ID_TOKEN',
  SETTINGS_VIEW: 'SETTINGS_VIEW',
  OOBE_TASKS: 'OOBE_TASKS',
  EMR_INTEGRATION_DETAILS: 'EMR_INTEGRATION_DETAILS',
  AMWELL_VIEW: 'AMWELL_VIEW',
  LOGOUT_EVENT: 'LOGOUT_EVENT',
  RE_WRITE_TRANSFER_TOKEN: 'RE_WRITE_TRANSFER_TOKEN'
}

export const SETTINGS_VIEW = {
  SCRIPTS: 'SCRIPTS',
  NOTETYPES: 'NOTETYPES'
}

export const SESH_STO = {
  CURRENT_ORGANIZATION: 'CURRENT_ORGANIZATION',
  USER_ID: 'USER_ID',
  TAB_ID: 'TAB_ID',
  SOCKET_AUTHENTICATED: 'SOCKET_AUTHENTICATED',
  DISABLE_AGENT: 'DISABLE_AGENT',

  AGENT_MUTED: 'AGENT_MUTED',
  AGENT_RECORDING: 'AGENT_RECORDING',
  KEYBOARD_MODE: 'KEYBOARD_MODE',
  LAST_AGENT_STATE: 'LAST_AGENT_STATE'
}

export const ENVIRONMENTS = {
  LOCAL: 'local',
  DEV: 'dev',
  TEST: 'test',
  STAGE: 'stage',
  PROD: 'prod'
}

export const ORG_IDS = {
  SUKI: '11111111-1111-1111-1111-111111111111',
  E2E: '22222222-2222-2222-2222-222222222222',
  DEMO: '33333333-3333-3333-3333-333333333333'
}

// Enum of StatusPage Statuses
// Ref: https://developer.statuspage.io/#operation/getPagesPageIdComponents
// Values on the left hand side, should match StatusPage API recommendations (but upperCased)
export const STATUSPAGE_COMPONENT_STATES = {
  OPERATIONAL: {
    label: 'All Systems OK',
    colors: {
      iconColor: dollarBill,
      textColor: charcoal
    }
  },
  UNDER_MAINTENANCE: {
    label: 'Under Maintenance',
    colors: {
      iconColor: greyShades.grey1,
      textColor: slateGrey
    }
  },
  DEGRADED_PERFORMANCE: {
    label: 'Degraded Performance',
    colors: {
      iconColor: pastelOrange,
      textColor: charcoal
    }
  },
  PARTIAL_OUTAGE: {
    label: 'Partial Outage',
    colors: {
      iconColor: fulvous,
      textColor: fulvous
    }
  },
  MAJOR_OUTAGE: {
    label: 'Major Outage',
    colors: {
      iconColor: burntSierra,
      textColor: burntSierra
    }
  },
  NOT_AVAILABLE: {
    label: 'Not Available',
    colors: {
      iconColor: greyShades.grey1,
      textColor: slateGrey
    }
  }
}

export const UPDATE_REASON = {
  TRANSCRIPTION: 'TRANSCRIPTION',
  MANUAL_EDIT: 'MANUAL_EDIT',
  MACRO: 'MACRO',
  MACHINE_EDIT: 'MACHINE_EDIT',
  COPY_FORWARD: 'COPY_FORWARD'
}

export const SLOT_TYPE = {
  SECTION: 'SECTION',
  PATIENT: 'PATIENT',
  NOTETYPE: 'NOTETYPE',
  MACRO: 'MACRO',
  TRANSCRIPT: 'TRANSCRIPT'
}

export const HALF_STORY = {
  CHANGE_SECTION: 'CHANGE_SECTION',
  CLICK: 'CLICK',
  CLICK_INSERT_SCRIPT: 'CLICK_INSERT_SCRIPT',
  CREATE_NOTE: 'CREATE_NOTE',
  EXIT_DICTATION_BADGE_PRESSED: 'EXIT_DICTATION_BADGE_PRESSED',
  KEYBOARD_MODE_OFF: 'KEYBOARD_MODE_OFF',
  MODAL: 'MODAL',
  VOICE: 'VOICE',
  NAVIGATION: 'NAVIGATION',
  NOTE_CREATED: 'NOTE_CREATED',
  NOTE_UPDATED: 'NOTE_UPDATED',
  NOTE_DELETED: 'NOTE_DELETED',
  NOTETYPE_UPDATED: 'NOTETYPE_UPDATED',
  NOTETYPE_DELETED: 'NOTETYPE_DELETED',
  SAVE_COMP_TO_UNFINISHED: 'SAVE_COMP_TO_UNFINISHED',
  SCRIPT_INSERTED: 'SCRIPT_INSERTED',
  SCRIPT_UPDATED: 'SCRIPT_UPDATED',
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  UPDATE_SECTION: 'UPDATE_SECTION'
}

export const ERROR = {
  PING_TIMEOUT: 'Reconnecting...'
}

export const DISCONNECT_REASON = {
  PING_TIMEOUT: 'ping timeout',
  TRANSPORT_CLOSE: 'transport close',
  IO_SERVER_DISCONNECT: 'io server disconnect'
}

// How many milliseconds a socket disconnect can
// occur before we display a warning to the user
export const DISCONNECT_TIMEOUT = 2000

export const GENDER = {
  FEMALE: 'Female',
  MALE: 'Male'
}

// More information on these fetch policies can be found at:
// https://www.apollographql.com/docs/react/api/react-apollo.html#graphql-config-options-fetchPolicy
export const FETCH_POLICY = {
  CACHE_FIRST: 'cache-first',
  CACHE_AND_NETWORK: 'cache-and-network',
  NETWORK_ONLY: 'network-only',
  CACHE_ONLY: 'cache-only',
  NO_CACHE: 'no-cache'
}

export const GQL_STATUS = {
  FAILED_PRECONDITION: 'FAILED_PRECONDITION'
}

export const MODAL_STRINGS = {
  IM_DONE_HEADING: 'Done entering note in Suki?',
  IM_DONE_BODY: 'Please confirm you are done. Suki will then process the note and submit it to your EMR, where you can review it.',

  IM_DONE_BYPASS_QA_HEADING: 'Send note to EMR',
  IM_DONE_BYPASS_QA_BODY: '',

  IM_DONE_DOCUMENT_HEADING: 'Done entering note in Suki?',
  IM_DONE_DOCUMENT_BODY: 'Please confirm you are done. Suki will then process the note and submit it as a read-only PDF in the patient\'s chart. Alternatively, you can save this note to your Unfinished Notes list for final review.',

  IM_DONE_DOC_SIGNOFF: 'Send note to patient\'s chart in EMR',

  EMPTY_NOTE_HEADING: 'Delete note?',
  EMPTY_NOTE_BODY: 'You haven\'t edited this note. Would you like to delete it?',

  UNKNOWN_PATIENT_HEADING: 'Unknown patient name. Save to unfinished notes?',
  UNKNOWN_PATIENT_BODY: 'The patient name is not set on this note, so it can\'t be sent to the EMR yet. Would you like to save this note to your Unfinished Notes list, and fill in the name later?',

  PDF_SUBMIT_HEADING: 'No open encounter for this patient',
  PDF_SUBMIT_BODY: 'This patient doesn\'t have an open encounter in the EMR. Would you like to submit this note as a PDF in the patient\'s chart?',

  NO_ENCOUNTER_HEADING: 'No open encounter for this patient',
  NO_ENCOUNTER_BODY: 'Oops! No encounter was found for this patient in your EMR. Save this note to Unfinished Notes and try again later, or reach out to us for help.',

  NO_OPEN_ENCOUNTER_HEADING: 'No Open Encounter',
  NO_OPEN_ENCOUNTER_BODY: 'Oops! No encounter found for this patient in the EMR. You can save this note to Unfinished Notes, so you can send to EMR later.',

  NOTE_SUBMISSION_WITHOUT_EMR_CONNECTION_HEADING: 'Not connected to your EMR',
  NOTE_SUBMISSION_WITHOUT_EMR_CONNECTION_BODY: 'This note will be saved with your Unfinished Notes so you can submit it to your EMR later',

  // Kept it generic so, we can use the message from the backend for any of the LAB RESULT cases
  NO_LAB_RESULTS_HEADING: 'No lab results found in EMR',
  NO_OB_FLOWSHEET_HEADING: 'No OB Episode and/or Flowsheet found in EMR',

  SIGN_OFF_HEADING: 'Sign Note',
  SIGN_OFF_BODY: 'By e-signing, you acknowledge and agree that you are solely responsible for the accuracy and completeness of your notes and meeting any third-party payor requirements.'
}

export const NOTE_EVENT_METRICS = {
  ENTERED: 'ENTERED',
  LEFT: 'LEFT'
}

export const EDITOR_TYPE = {
  SCRIPT: 'SCRIPT',
  NOTETYPE: 'NOTETYPE'
}

export const SUBMISSION_WARNING = {
  UNKNOWN: 'UNKNOWN',
  NO_ENCOUNTER: 'NO_ENCOUNTER',
  ENCOUNTER_NOT_OPEN: 'ENCOUNTER_NOT_OPEN',
  UNKNOWN_PATIENT: 'UNKNOWN_PATIENT',
  NO_LAB_RESULTS: 'NO_LAB_RESULTS',
  NO_VALID_OB_EPISODE: 'NO_VALID_OB_EPISODE'
}

export const EMR_DESTINATION = {
  SUKI_ONLY: 'SUKI_ONLY', // No EMR
  ENCOUNTER: 'ENCOUNTER', // Open  EMR encounter
  DOCUMENT: 'DOCUMENT',
  ENCOUNTER_NEEDS_SIGNOFF: 'ENCOUNTER_NEEDS_SIGNOFF',
  DOCUMENT_NEEDS_SIGNOFF: 'DOCUMENT_NEEDS_SIGNOFF'
}

export const CLIENT_TYPE = {
  WEB: 'WEB'
}

export const SUKI_ROLE = {
  ADMIN: 'ADMIN',
  SCRIBE: 'SCRIBE',
  PHYSICIAN: 'PHYSICIAN'
}

export const EMR_TYPE = {
  ATHENA: 'ATHENA',
  REDOX: 'REDOX',
  ELATION: 'ELATION',
  ALLSCRIPTS: 'ALLSCRIPTS',
  MIRTH: 'MIRTH'
}

export const SECONDARY_EMR_TYPE = {
  ATHENA_EMR: 'ATHENA_EMR',
  ELATION_EMR: 'ELATION_EMR',
  CERNER_EMR: 'CERNER_EMR',
  EPIC_EMR: 'EPIC_EMR'
}

export const SCRIPT_TAG = {
  NAME: 'MACRO_NAME',
  TYPE: 'MACRO_TYPE'
}

export const DISAMBIG = {
  CREATE_NOTE_NOTETYPE: 'CREATE_NOTE_NOTETYPE',
  CREATE_NOTE_PATIENT: 'CREATE_NOTE_PATIENT',
  PATIENT_PROFILE: 'PATIENT_PROFILE',
  SCRIPTS: 'SCRIPTS'
}

export const FEATURE_FLAG = {
  BYPASS_QA: 'bypass-qa',
  EDITOR_V2: 'editor-v2'
}

export const SUBMIT_PREFERENCE = {
  BYPASS_QA: 'BYPASS_QA',
  WITH_QA: 'WITH_QA'
}

export const ICD10_MODAL = {
  DIAGNOSTICS_ML: 'Suggestions',
  DIAGNOSTICS: '',
  CHILD: 'Child'
}

export const CONFIRM_STATUS = {
  UNKNOWN: 'UNKNOWN',
  UNCONFIRMED: 'UNCONFIRMED',
  CONFIRMED: 'CONFIRMED'
}

// Intercom Events
// https://docs.google.com/document/d/1c5zmeUsO3JsNwFrjITmziGclJ-A5ojGPdJP8QDIiGOE/edit
export const INTERCOM_EVENTS = {
  SCRIPT_INSERTED: 'scriptInserted',
  NOTE_CREATED: 'noteCreatedWeb',
  USED_DICTATION: 'usedDictation',
  USED_TYPE_EDIT: 'usedTypeEdit',
  NOTE_SUKI_PROCESS_FIRST: 'noteSukiProcessFirst',
  NOTE_BYPASS_OPS: 'noteBypassedOps',
  USED_COPY_FORWARD: 'usedCopyForward',
  SHOW_SCRIPTS: 'showScripts',
  USED_PBN: 'usedPBN'
}

export const WINDOW_EVENTS = {
  STORAGE: 'storage',
  BEFORE_UNLOAD: 'beforeunload'
}

export const NOTE_QUEUE_STATUS = {
  NOTE_IS_BEING_EDITED: 'NOTE_IS_BEING_EDITED'
}

// 60 minute timeout.
export const INACTIVITY_TIMEOUT = 1000 * 60 * 59.5

export const CURRENT_SECTION = {
  id: '11111111-1111-1111-1111-111111111111',
  createdBy: '11111111-1111-1111-1111-111111111111',
  name: 'Any Section'
}

export const RESPONSIVE = {
  CLOSE_SIDEBAR_WIDTH: '1050px',
  SMALL_LIST_PANEL_WIDTH: '600px',
  CRAMPED_LIST_PANEL_WIDTH: '1050px',
  AGENT_SMALL_WIDTH: '600px',
  AGENT_CRAMPED_WIDTH: '1050px',
  NOTE_SMALL_WIDTH: '1050px',
  NOTE_LARGE_WIDTH: '900px',
  MODAL_FULL_WIDTH: 'calc(100vw - 20px)',
  MODAL_MED_WIDTH: '600px',
  MODAL_LARGE_WIDTH: '800px'
}

export const AGENT_CONFIGS = {
  FORCE_MIDDLE: 'MIDDLE'
}

export const AMWELL_COLORS = {
  MODAL_BG_DARK: 'rgb(45,55,64)',
  PRIMARY_CTA_BLUE: '#46aff2',
  DISABLED_BUTTON_CTA_BLUE: 'rgb(70, 175, 242, 0.25)'
}

export const LIST_PANEL_TOP_MARGIN_WITH_EHR_INTEGRATION_TOOLBAR = 138

export const NOTE_EDITOR_TOP_MARGIN_WITH_EHR_INTEGRATION_TOOLBAR = 128

export const EMR_INTEGRATION_STATUS = {
  CONNECTED: 'CONNECTED',
  PENDING: 'PENDING',
  FAILED: 'FAILED'
}

export const APPOINTMENT_TYPES = {
  DEFAULT: 'DEFAULT',
  EHR_GENERATED: 'EHR_GENERATED',
  FOLLOW_UP: 'FOLLOW_UP',
  NEW: 'NEW',
  NON_EMR_USER_GENERATED: 'NON_EMR_USER_GENERATED',
  POST_OP: 'POST_OP',
  PRE_OP: 'PRE_OP'
}
